import axios from 'axios';
import http from '@/services/http';

let cancelShiftsSrc = null;

export default {
  namespaced: true,
  state: {
    couriers: [],
  },
  mutations: {
    /**
     * вызовется в orders модуле
     */
    SET_COURIERS(state, couriers) {
      state.couriers = couriers;
    },
    PATCH_COURIER(state, { courier_id, data }) {
      const courierIndex = state.couriers.findIndex(
        (c) => c.courier_id === courier_id
      );
      if (courierIndex !== -1) {
        const courier = state.couriers[courierIndex];
        state.couriers.splice(
          courierIndex,
          1,
          Object.assign({}, courier, data)
        );
      }
    },
  },
  actions: {
    async getCoutierDetail({ commit, rootState }, { courier_id, current }) {
      const options = {};
      if (current) {
        options.params = {
          current: true,
        };
      }
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        const res = await http.get(
          `manufacture/${rootState.manufactures.selectedManufacture.id}/couriers/${courier_id}/detail`,
          options
        );
        return res;
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
    async getCourierInventory({ commit }, courier_id) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        const res = await http.get(`courier_inventory/${courier_id}`);
        return res;
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
    async getShifts({ rootState }) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      cancelShiftsSrc = source;
      const res = await http.get(
        `manufacture/${rootState.manufactures.selectedManufacture.id}/shifts`,
        {
          cancelToken: source.token,
        }
      );
      return res;
    },
    cancelGetShifts() {
      if (cancelShiftsSrc) {
        cancelShiftsSrc.cancel();
      }
    },
    async createNewShift({ rootState }, data) {
      await http.post(
        `manufacture/${rootState.manufactures.selectedManufacture.id}/new_shift`,
        data
      );
    },
    async setActionShift({ rootState }, { shift_id, data }) {
      await http.post(
        `manufacture/${rootState.manufactures.selectedManufacture.id}/shifts/${shift_id}`,
        data
      );
    },
    async uploadShiftsFile({ rootState }, data) {
      return await http.post(
        `manufacture/${rootState.manufactures.selectedManufacture.id}/upload_shifts_file`,
        data
      );
    },
    async getShedule({ rootState }, weekStart) {
      const res = await http.get(
        `manufacture/${rootState.manufactures.selectedManufacture.id}/schedule`,
        {
          params: {
            week_start: weekStart,
          },
        }
      );
      return res;
    },
    async patchCourier({ rootState, commit }, { courier_id, data }) {
      const res = await http.patch(
        `manufacture/${rootState.manufactures.selectedManufacture.id}/couriers/${courier_id}`,
        data
      );
      commit('PATCH_COURIER', { courier_id, data });
      return res;
    },
    async createGain({ rootState, commit }, { shift_id, data }) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        const res = await http.post(
          `manufacture/${rootState.manufactures.selectedManufacture.id}/shifts/${shift_id}/gain`,
          data
        );
        return res;
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
    async postFuelTransaction({ rootState, commit }, { shift_id, data }) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        const res = await http.post(
          `manufacture/${rootState.manufactures.selectedManufacture.id}/fuel_money/shift/${shift_id}`,
          data
        );
        return res;
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
    async patchFuelTransaction(
      { rootState, commit },
      { transaction_id, data }
    ) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        const res = await http.patch(
          `manufacture/${rootState.manufactures.selectedManufacture.id}/fuel_money/transaction/${transaction_id}`,
          data
        );
        return res;
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
    async deleteGain({ rootState, commit }, shiftId) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        await http.delete(
          `manufacture/${rootState.manufactures.selectedManufacture.id}/shifts/${shiftId}/gain`
        );
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
    async deleteShift({ rootState, commit }, shiftId) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        await http.delete(
          `manufacture/${rootState.manufactures.selectedManufacture.id}/shifts/${shiftId}`
        );
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
    async getShiftPhotos({ commit }, shiftId) {
      try {
        commit('pageLoader/SET_LOADING', true, { root: true });
        const res = await http.get(`shift/${shiftId}/photos`, { v3: true });
        return res;
      } finally {
        commit('pageLoader/SET_LOADING', false, { root: true });
      }
    },
  },
};
